/**
 * 运营活动相关接口
 */

const operate = {
  /**
   * @module 公众号绑定模块
   */
  checkGzhMsgCheckBind: ['/lt-web/xs/gzh/msg/checkBind'], // 判断用户是否已绑定
  getGzhMsgGetCreditToken: ['/lt-web/xs/gzh/msg/getCreditToken'], // 发送注册短信验证码
  sendGzhMsgSendCode: ['/lt-web/xs/gzh/msg/sendCode'], // 发送验证码
  submitGzhMsgBind: ['/lt-web/xs/gzh/msg/bind'], // 绑定用户
  /**
   * @module 我的红包模块
   */
  // 我的红包
  getRedEnvelopesMyList: ['/lt-web/app/act/redEnvelopes/my'], // 获取我的红包数据
  getRedEnvelopesList: ['/lt-web/app/act/redEnvelopes/my/redEnvelopes/list'], // 我的红包列表
  getApplyRecord: ['/lt-web/app/act/redEnvelopes/my/apply/list'], // 兑换记录列表
  submitRedEnvelopesApply: ['/lt-web/app/act/redEnvelopes/apply/cash'], // 确定兑换
  getRedBankCardList: ['/lt-web/app/act/redEnvelopes/bankCard/list'], // 获取银行卡列表
  addOrDeleteRedEnvelopesBankCard: ['/lt-web/app/act/redEnvelopes/bankCard/add'], // 新增/解绑银行卡
  // 微信公众号提现相关接口
  getRedEnvelopesMode: ['/lt-web/app/act/redEnvelopes/getMode'], // 获取当前红包提现的模式
  getRedEnvelopesApplyList: ['/lt-web/app/act/redEnvelopes/red/applyList'], // 获取红包列表
  checkRedEnvelopesApply: ['/lt-web/app/act/redEnvelopes/red/applyCheck'], // 校验红包是否可以领取
  getXcxWxPaySignature: ['/lt-web/xcx/common/wxPay/signature'], // 获取签名信息
  sendRedNotify: ['/lt-web/app/act/redEnvelopes/red/notify'] // 通知行为
}

export default operate
